// extracted by css-extract-rspack-plugin
export default {"root":"ActionIcon-module__root___z3URy"};